// 기기 카테고리 및 서브카테고리 관련 상수들

// 태블릿 서브카테고리
export const TABLET_SUBCATEGORIES = ['iPad Pro', 'iPad Air', 'iPad', 'iPad mini'];

// 🤖 Samsung 태블릿 서브카테고리 (Firebase 기반)
export const SAMSUNG_TABLET_SUBCATEGORIES = [
  'Galaxy Tab S',      // 프리미엄 (S9, S8, S7 등)
  'Galaxy Tab A',      // 보급형 (A9, A8, A7 등)  
  'Galaxy Tab Active', // 업무용 (Active5, 4Pro 등)
  'Galaxy Tab Pro',    // 구형 프로 (12.2, 10.1 등)
  'Galaxy Tab E',      // 엔트리
  'Galaxy Tab 4',      // 구형 (4세대)
  'Galaxy Tab 3',      // 구형 (3세대) 
  'Galaxy Tab 2',      // 구형 (2세대)
  'Galaxy Tab'         // 1세대 및 기타
];

// 🍎 iPhone 시리즈 서브카테고리 (11개 시리즈)
export const IPHONE_SERIES_SUBCATEGORIES = [
  'iPhone 17',    // 최신 (17, 17AIR, 17Pro, 17ProMax)
  'iPhone 16',    // 2024년 (16, 16+, 16Pro, 16ProMax, 16e)  
  'iPhone 15',    // 2023년 (15, 15+, 15Pro, 15ProMax)
  'iPhone 14',    // 2022년 (14, 14+, 14Pro, 14ProMax)
  'iPhone 13',    // 2021년 (13, 13mini, 13Pro, 13ProMax)
  'iPhone 12',    // 2020년 (12, 12mini, 12Pro, 12ProMax)
  'iPhone 11',    // 2019년 (11, 11Pro, 11ProMax)
  'iPhone X',     // 2017-2018년 (X, XS, XSMax, XR)
  'iPhone 8',     // 2017년 (8, 8+)
  'iPhone 7',     // 2016년 (7, 7+)  
  'iPhone 6',     // 2014-2015년 (6, 6+, 6S, 6S+)
  'iPhone SE'     // 특별판 (SE, SE2, SE3)
];

// 🤖 Galaxy 시리즈 서브카테고리 (6개 시리즈)
export const GALAXY_SERIES_SUBCATEGORIES = [
  'Galaxy S',        // 프리미엄 (S25, S24, S23, S22, S21, S20, S10)
  'Galaxy Z Flip',   // 폴더블 (Flip7, Flip6, Flip5, Flip4, Flip3)
  'Galaxy Z Fold',   // 대형 폴더블 (Fold7, Fold6, Fold5, Fold4, Fold3, Fold2)
  'Galaxy Note',     // 대형 (Note20, Note10, Note9, Note8, Note7)
  'Galaxy A',        // 중급 (A73, A54, A34, A25, A15, A14, A13, A12, A11, A10)
  'Galaxy J'         // 보급형 (J8, J7, J6, J5, J4, J3, J2, J1)
];
